import client from '@/api/client';
import { gql } from '@apollo/client';
import fragments from '@/gql-fragments/lesson';

const getLevels = () => client
  .query({
    query: gql`
      query {
        getLevels {
          id
          title
        }
      }
    `,
  });

const getLessons = (courseId: number) => client
  .query({
    query: gql`
      query($courseId: Int) {
        getLessons(courseId: $courseId) {
          ...Lesson
        }
      }
      ${fragments.Lesson}
    `,
    variables: {
      courseId,
    },
  });

const getLesson = (lessonId: number) => client
  .query({
    query: gql`
      query($lessonId: Int) {
        getLesson(lessonId: $lessonId) {
          ...Lesson
        }
      }
      ${fragments.Lesson}
    `,
    variables: {
      lessonId,
    },
  });

const getLessonRate = (lessonId: number) => client
  .query({
    query: gql`
      query($lessonId: Int) {
        getLessonRate(lessonId: $lessonId) {
          rate {
            platform_stability
            teaching_materials
            rate_teacher
          }
        }
      }
    `,
    variables: {
      lessonId,
    },
  });

const setLessonRate = (
  lessonId: number,
  platformStability: number,
  teachingMaterials: number,
  rateTeacher: number,
  comment?: string,
) => client
  .mutate({
    mutation: gql`
      mutation($lessonId: Int, $platformStability: Int, $teachingMaterials: Int, $rateTeacher: Int, $comment: String) {
        setLessonRate(lessonId: $lessonId, platformStability: $platformStability, teachingMaterials: $teachingMaterials, rateTeacher: $rateTeacher, comment: $comment) {
          status
        }
      }
    `,
    variables: {
      lessonId,
      platformStability,
      teachingMaterials,
      rateTeacher,
      comment,
    },
  });

export default {
  getLevels,
  getLessons,
  getLesson,
  getLessonRate,
  setLessonRate,
};
